<template>
  <div>
    <v-expansion-panels accordion multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>
          ปุ่มเข้าสู่ระบบผ่าน ONEID
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="px-0"> ข้อความ </v-card-text>
            <v-card-text class="pa-0">
              <v-text-field
                v-model="welcome_theme.oneid.login_button.text"
                outlined
                dense
                maxlength="30"
                counter="30"
              ></v-text-field>
            </v-card-text>
            <v-card-text class="pa-0">
              <v-radio-group
                v-model="welcome_theme.oneid.login_button.bt_texttype"
                hide-details=""
                @change="StartOneIDButtonUI"
              >
                <template v-slot:label> รูปแบบปุ่ม </template>
                <v-radio value="button">
                  <template v-slot:label>
                    <div>แบบที่ 1</div>
                  </template>
                </v-radio>
                <v-radio value="text">
                  <template v-slot:label>
                    <div>แบบที่ 2</div>
                  </template>
                </v-radio>
                <v-radio value="outlined">
                  <template v-slot:label>
                    <div>แบบที่ 3</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-text class="pa-0">
              <v-checkbox
                v-model="welcome_theme.oneid.login_button.bt_block"
                label="ปุ่มยาวเต็มกรอบ"
                hide-details=""
              ></v-checkbox>
            </v-card-text>
            <v-card-text class="px-0">
              <v-checkbox
                v-model="welcome_theme.oneid.login_button.bt_rounded"
                label="ขอบมน"
                hide-details=""
              ></v-checkbox>
            </v-card-text>
            <v-card-text
              v-show="welcome_theme.oneid.login_button.bt_texttype === 'button'"
              class="pa-0"
            >
              สีพื้นหลังปุ่ม
            </v-card-text>
            <v-card-text
              v-show="welcome_theme.oneid.login_button.bt_texttype === 'button'"
              class="pa-0"
            >
              <v-color-picker
                v-model="welcome_theme.oneid.login_button.bg_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0">
              สีข้อความ / สีเส้นขอบของปุ่ม
            </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="welcome_theme.oneid.login_button.text_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          ปุ่มลงทะเบียน ONEID
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="pa-0">
              <v-checkbox
                v-model="welcome_theme.oneid.showreg"
                label="แสดงปุ่มลงทะเบียน ONEID"
                hide-details=""
              ></v-checkbox>
            </v-card-text>
            <div v-if="welcome_theme.oneid.showreg">
              <v-card-text class="px-0"> ข้อความเชิญชวน </v-card-text>
              <v-card-text class="pa-0">
                <v-text-field
                  v-model="welcome_theme.oneid.texttoreg"
                  outlined
                  dense
                  clearable
                  maxlength="35"
                  counter="35"
                ></v-text-field>
              </v-card-text>
              <v-card-text class="px-0"> สีข้อความเชิญชวน </v-card-text>
              <v-card-text class="pa-0">
                <v-color-picker
                  v-model="welcome_theme.oneid.texttoreg_color"
                  class="my-6"
                ></v-color-picker>
              </v-card-text>
              <v-card-text class="px-0"> ข้อความ </v-card-text>
              <v-card-text class="pa-0">
                <v-text-field
                  v-model="welcome_theme.oneid.reg_button.text"
                  outlined
                  dense
                  maxlength="30"
                  counter="30"
                ></v-text-field>
              </v-card-text>
              <v-card-text class="pa-0">
                <v-radio-group
                  v-model="welcome_theme.oneid.reg_button.bt_texttype"
                  hide-details=""
                  @change="RegOneIDButtonUI"
                >
                  <template v-slot:label> รูปแบบปุ่ม </template>
                  <v-radio value="button">
                    <template v-slot:label>
                      <div>แบบที่ 1</div>
                    </template>
                  </v-radio>
                  <v-radio value="text">
                    <template v-slot:label>
                      <div>แบบที่ 2</div>
                    </template>
                  </v-radio>
                  <v-radio value="outlined">
                    <template v-slot:label>
                      <div>แบบที่ 3</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-card-text>
              <v-card-text class="pa-0">
                <v-checkbox
                  v-model="welcome_theme.oneid.reg_button.bt_block"
                  label="ปุ่มยาวเต็มกรอบ"
                  hide-details=""
                ></v-checkbox>
              </v-card-text>
              <v-card-text class="px-0">
                <v-checkbox
                  v-model="welcome_theme.oneid.reg_button.bt_rounded"
                  label="ขอบมน"
                  hide-details=""
                ></v-checkbox>
              </v-card-text>
              <v-card-text
                v-show="welcome_theme.oneid.reg_button.bt_texttype === 'button'"
                class="pa-0"
              >
                สีพื้นหลังปุ่ม
              </v-card-text>
              <v-card-text
                v-show="welcome_theme.oneid.reg_button.bt_texttype === 'button'"
                class="pa-0"
              >
                <v-color-picker
                  v-model="welcome_theme.oneid.reg_button.bg_color"
                  class="my-6"
                ></v-color-picker>
              </v-card-text>
              <v-card-text class="pa-0">
                สีข้อความ / สีเส้นขอบของปุ่ม
              </v-card-text>
              <v-card-text class="pa-0">
                <v-color-picker
                  v-model="welcome_theme.oneid.reg_button.text_color"
                  class="my-6"
                ></v-color-picker>
              </v-card-text>
            </div>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: ["welcome_theme"],
  mounted() {
    if (this.welcome_theme) {
      if (this.welcome_theme.oneid.showreg_btn === undefined) {
        this.welcome_theme.oneid.showreg_btn = true;
      }
    }
  },
  methods: {
    StartOneIDButtonUI() {
      let bg_color = this.welcome_theme.wc_color;
      let button_bg_color = this.welcome_theme.oneid.login_button.bg_color;
      let button_text_color = this.welcome_theme.oneid.login_button.text_color;
      if (
        this.welcome_theme.oneid.login_button.bt_texttype === "text" ||
        this.welcome_theme.oneid.login_button.bt_texttype === "outlined"
      ) {
        if (
          bg_color === button_text_color &&
          button_bg_color !== button_text_color
        ) {
          this.welcome_theme.oneid.login_button.text_color = button_bg_color;
        }
      } else {
        if (
          this.welcome_theme.oneid.login_button.text_color === button_bg_color
        ) {
          this.welcome_theme.oneid.login_button.text_color = bg_color;
        }
      }
    },
    RegOneIDButtonUI() {
      let bg_color = this.welcome_theme.wc_color;
      let button_bg_color = this.welcome_theme.oneid.reg_button.bg_color;
      let button_text_color = this.welcome_theme.oneid.reg_button.text_color;
      if (
        this.welcome_theme.oneid.reg_button.bt_texttype === "text" ||
        this.welcome_theme.oneid.reg_button.bt_texttype === "outlined"
      ) {
        if (
          bg_color === button_text_color &&
          button_bg_color !== button_text_color
        ) {
          this.welcome_theme.oneid.reg_button.text_color = button_bg_color;
        }
      } else {
        if (
          this.welcome_theme.oneid.reg_button.text_color === button_bg_color
        ) {
          this.welcome_theme.oneid.reg_button.text_color = bg_color;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
